import { SubmitHandler } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { NewUserStep1 } from '~api/models'
import { setCurrentStep, updateFormStepValues } from '~store/wizardNewUser/actions'
import { OnBack, StepProps } from '~shared/components/reactHookForm/MultiStepForm/useMultiStepForm'

import Step1Form from './Step1Form'
import { NewUserStep1Schema } from './Step1.schema'

type Step1Hook = () => StepProps<NewUserStep1>

export const useStep1: Step1Hook = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onSubmit: SubmitHandler<NewUserStep1> = (formValues): void => {
    dispatch(setCurrentStep('step2'))
    dispatch(updateFormStepValues({ step: 'step1', values: formValues }))
  }
  const onBack: OnBack<NewUserStep1> = (formValues) => {
    // onBack in unnecessary in step1, but i did not find a good way to make it optional
    // so the simplest way is to just provide it^^
    // improvement proposal -- fix this situation
    dispatch(updateFormStepValues({ step: 'step1', values: formValues }))
  }

  return {
    onSubmit,
    onBack,
    component: Step1Form,
    validationSchema: NewUserStep1Schema,
    label: t('form:newUserFormStep1Label'),
  }
}
